/**
* 公司数据仓库
*/
const contract = {
  
  addElectricOperationsContract: "/api/addElectricOperationsContract",//添加电力运维合同
  listElectricOperationsContractForClient: "/api/listElectricOperationsContractForClient",//客户查看电力运维合同
  listElectricOperationsContractForServiceProvider: "/api/listElectricOperationsContractForServiceProvider",//服务提供公司查看电力运维合同
  terminateElectricOperationsContract: "/api/terminateElectricOperationsContract",//终止电力运维合同
  listClientsForElectricOperationsCompany: "/api/listClientsForElectricOperationsCompany",//维保公司查看所有客户
  listElectricOperationsCompaniesForClient: "/api/listElectricOperationsCompaniesForClient",//客户查看所有维保公司
  addElectricOperationsPlanByContractServiceItem: "/api/addElectricOperationsPlanByContractServiceItem",//添加电力运维计划
  addElectricOperationsPlan: "/api/addElectricOperationsPlan",//添加电力运维计划
  cancelElectricOperationsPlan: "/api/cancelElectricOperationsPlan",//取消电力运维计划
  modifyElectricOperationsPlan: "/api/modifyElectricOperationsPlan",//修改电力运维计划
  listElectricOperationsPlans: "/api/listElectricOperationsPlans",//查询电力运维计划
  addElectricOperationsWorkOrder: "/api/addElectricOperationsWorkOrder",//添加电力运维工单
  changeElectricOperationsWorkOrderState: "/api/changeElectricOperationsWorkOrderState",//修改电力运维工单状态
  listElectricOperationsWorkOrderStateChangingHistory: "/api/listElectricOperationsWorkOrderStateChangingHistory",//查看工单状态变更历史
  setElectricOperationsWorkOrderToWorkBase: "/api/setElectricOperationsWorkOrderToWorkBase",//设置电力运维工单所属基地站点
  setElectricOperationsWorkOrderExecutor: "/api/setElectricOperationsWorkOrderExecutor",//设置电力运维工单执行人
  listAllCompany: "/api/listAllCompany",//获取全部公司
  listAllUserByCompany: "/api/listAllUserByCompany",//获取公司下所有职员

  }
  
  export default contract